import $ from 'jquery';

$( document ).on('turbolinks:load', function() {
  $('[data-toggle="tooltip"]').tooltip();
})
